export const CHECKBOX_TYPE_MAILING_FORM = 'mailingForm' as const;
export const CHECKBOX_TYPE_BENEFICIARY_SUBMITTED = 'beneficiarySubmitted' as const;
export const CHECKBOX_TYPE_NO_FORM_NEEDED = 'noFormNeeded' as const;

export type CheckboxType =
  | typeof CHECKBOX_TYPE_MAILING_FORM
  | typeof CHECKBOX_TYPE_BENEFICIARY_SUBMITTED
  | typeof CHECKBOX_TYPE_NO_FORM_NEEDED;
